export default __webpack_public_path__ + "static/media/card5.af4b2fa5.jpg";